import { render, staticRenderFns } from "./UiPrint.vue?vue&type=template&id=4bfd04cf&lang=pug&"
import script from "./UiPrint.vue?vue&type=script&lang=js&"
export * from "./UiPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports